import { ReactNode } from 'react'

type BadgeVariant = 'default' | 'primary' | 'secondary' | 'accent' | 'success' | 'warning' | 'error' | 'info'
type BadgeSize = 'sm' | 'md' | 'lg'

interface BadgeProps {
  children: ReactNode
  variant?: BadgeVariant
  size?: BadgeSize
  outline?: boolean
  className?: string
}

export function Badge({ 
  children, 
  variant = 'default', 
  size = 'md', 
  outline = false,
  className = '' 
}: BadgeProps) {
  const baseClasses = 'badge'
  
  const variantClasses: Record<BadgeVariant, string> = {
    default: '',
    primary: 'badge-primary text-white',
    secondary: 'badge-secondary text-white',
    accent: 'badge-accent text-white',
    success: 'badge-success text-white',
    warning: 'badge-warning text-white',
    error: 'badge-error text-white',
    info: 'badge-info text-white',
  }
  
  const sizeClasses: Record<BadgeSize, string> = {
    sm: 'badge-sm',
    md: '',
    lg: 'badge-lg',
  }
  
  const outlineClass = outline ? 'badge-outline' : ''
  
  const classes = [
    baseClasses,
    variantClasses[variant],
    sizeClasses[size],
    outlineClass,
    className
  ].filter(Boolean).join(' ')
  
  return <span className={classes}>{children}</span>
}
